export default __webpack_public_path__ + "static/media/Curvet.2b3dde30.svg";